import { useEffect, useState } from 'react';
import type { TvConfig } from '../components/tvLinkModel.js';

/**
 * The server's `/api/config` answer, fetched once for the whole console.
 *
 * Localhost needs the LAN addresses so QR/cast URLs are reachable. A hosted
 * console already has a reachable origin, but still needs `castAppId` so the
 * table-row Cast buttons can take the native Google Cast path.
 */
export function useTvConfig(_origin: string): TvConfig | null {
  const [config, setConfig] = useState<TvConfig | null>(null);

  useEffect(() => {
    fetch('/api/config')
      .then((r) => r.json())
      .then((c: TvConfig) => setConfig(c))
      .catch(() => undefined);
  }, []);

  return config;
}
